<template>
  <div id="app">
    <BackgroundMusic />
    <el-container>
      <el-header>
        <div class="logo" style="white-space: nowrap;"> <!-- 防止换行 -->  
          <img src="./assets/img/ZhongXinLogo.png" style="width: 50px; height: auto; vertical-align: middle; display: inline-block;" />  
          <span style="display: inline-block; vertical-align: middle; margin-left: 10px; font-size: 25px;">安徽众心集团</span>  
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/goin">走进众心</el-menu-item>
          <el-menu-item index="/companies">集团架构</el-menu-item>
          <el-menu-item index="/news">新闻中心</el-menu-item>
          <el-menu-item index="/project">项目展示</el-menu-item>
          <!-- <el-menu-item index="/product">产品中心</el-menu-item> -->
          
          
          <!-- <el-menu-item index="/download">下载APP</el-menu-item> -->
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="isShow">
        <div class="footer-content">
          <ul class="content-nav">
            <!-- <li>
              <p>走进科建</p>
              <span>发展历程</span>
              <span>企业文化</span>
              <span>资质荣誉</span>
              <span>合作伙伴</span>
            </li>
            <li>
              <p>新闻资讯</p>
              <span>公司新闻</span>
              <span>行业动态</span>
            </li>
            <li>
              <p>产品中心</p>
              <span>介绍视频</span>
              <span>管理模式</span>
              <span>平台目标</span>
              <span>功能模块</span>
            </li> -->
            <li>
              <p>联系我们</p>
              <span>邮箱：xxxxx@163.com</span>
              <span>电话：xxx-xxxxxxx</span>
              <span>地址：安徽省亳州市xxxx</span>
              <span>访问量：{{ visitCount.num }}</span>
              <!-- <div>
                <h1>访问量：{{ visitCount.num }} </h1>
              </div> -->
            </li>
          </ul>
          <img src="./assets/cases/erweima.png" alt />
        </div>
        <div class="copyright">
          <span>安徽众心版权所有</span>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import BackgroundMusic from './components/BackgroundMusic.vue';
export default {
  name: 'App',
  components: {
    BackgroundMusic
  },
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      visitCount: 0
    };
  },
  mounted() {
    // 检查 sessionStorage 中是否已有访问标志
    if (!sessionStorage.getItem('hasVisited')) {
      // 如果没有访问标志，表示用户是首次访问
      this.incrementVisitCount(); // 增加访问量
      sessionStorage.setItem('hasVisited', 'true'); // 设置标志，避免后续增加访问量
    }

    // 获取当前的访问量
    this.getVisitCount();
  },
  methods: {
    // 获取访问量
    async getVisitCount() {
      try {
        const response = await this.$axios.get(`${this.$apiBaseUrl}//findVisit`)
        this.visitCount = response.data;  // 更新当前访问量
      } catch (error) {
        window.console.error("获取访问量失败", error);
      }
    },

    // 增加访问量
    async incrementVisitCount() {
      try {
        await this.$axios.post(`${this.$apiBaseUrl}//incrementVisitCount`)
        this.getVisitCount();
      } catch (error) {
        window.console.error("增加访问量失败", error);
      }
    },
    
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;
    img {
      width: 100%;
      line-height: 60px;
    }
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 216px;
  overflow: hidden;
  background-color: #14679f;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: #125688;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
